import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function SidebarDashboard() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/");
  };
  return (
    <nav className="sidebar">
      <div className="sidebar-header">
        <Link to="/dashboard" className="sidebar-brand">
          <img src="/images/logo.png" alt="logo" className="w-75" width={75} />
        </Link>
        <div className="sidebar-toggler not-active">
          <span />
          <span />
          <span />
        </div>
      </div>
      <div className="sidebar-body">
        <ul className="nav">
          <li className="nav-item active">
            <Link to="/dashboard/" className="nav-link">
              <i className="link-icon" data-feather="box" />
              <span className="link-title">Dashboard</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/dashboard/bookings" className="nav-link">
              <i className="link-icon" data-feather="calendar" />
              <span className="link-title">My Bookings</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/" className="nav-link">
              <i className="link-icon" data-feather="calendar" />
              <span className="link-title">New Booking</span>
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/dashboard/profile" className="nav-link">
              <i className="link-icon" data-feather="user" />
              <span className="link-title">Profile</span>
            </Link>
          </li>
          <li className="nav-item">
            <a
              href="#"
              className="nav-link"
              onClick={(e) => {
                e.preventDefault();
                handleLogout();
              }}
            >
              <i className="link-icon" data-feather="log-out" />
              <span className="link-title">Logout</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}
